"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var StackBar = /** @class */ (function (_super) {
    tslib_1.__extends(StackBar, _super);
    function StackBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackBar.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'stackBar';
        _super.prototype.createLayers.call(this, layerProps);
    };
    StackBar.getDefaultOptions = layer_1.default.getDefaultOptions;
    return StackBar;
}(plot_1.default));
exports.default = StackBar;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/stack-bar/index.js
// module id = 980
// module chunks = 37